import React, { Component, ChangeEvent } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import {
  Col,
  Row,
  Form,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Label,
  Input,
  FormGroup,
  Progress
} from 'reactstrap';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import InputGroup from '../Forms/InputGroup';
import classnames from 'classnames';
import { getTranslationKey } from '../../modules/utils/helpers';
import { FaRegTrashAlt } from 'react-icons/fa';
import theme from '../../assets/css/theme';
import { partial } from 'lodash';
import axios from '../../helpers/axios';
import type { Notify } from '../../typings/redux';

interface FieldConfig {
  type: string;
  title?: string;
  placeholder?: string;
}

interface FieldsConfig {
  [key: string]: FieldConfig;
}

let contactInfoFields: FieldsConfig = {};
let socialFields: FieldsConfig = {};
let legalFields: FieldsConfig = {};

interface ImageData {
  url: string;
  originalImageName: string;
  [key: string]: any;
}

interface Auth {
  type: string;
  company?: string;
  custom_imprint?: string;
  custom_privacy?: string;
  defaultUserBrand: any;
  languageApp: number;
  whiteLabel: boolean;
  registrationProcess: {
    setDefaultValues: boolean;
    [key: string]: any;
  };
  defaultValues?: any;
  [key: string]: any;
}

interface ButtonStyle {
  color?: string;
}

interface Styles {
  backgroundColor?: string;
}

interface InitialValues {
  logo?: ImageData;
  logoLight?: ImageData;
  icon?: ImageData;
  studioLogo?: ImageData;
  buttonStyle?: ButtonStyle;
  styles?: Styles;
  customDomain?: string | null;
  custom_imprint?: string;
  custom_privacy?: string;
  [key: string]: any;
}

interface SetDefaultValuesFormValues {
  company?: string;
  website?: string;
  email?: string;
  tel?: string;
  facebook?: string;
  instagram?: string;
  twitter?: string;
  pinterest?: string;
  youtube?: string;
  linkedin?: string;
  googleReviews?: string;
  custom_imprint?: string;
  custom_privacy?: string;
  [key: string]: any;
}

interface SetDefaultValuesState {
  activeTab: string;
  logo?: ImageData;
  logoLight?: ImageData;
  icon?: ImageData;
  studioLogo?: ImageData;
  logoUploading?: boolean;
  logoLightUploading?: boolean;
  iconUploading?: boolean;
  studioLogoUploading?: boolean;
  logoImagename?: string;
  logoLightImagename?: string;
  iconImagename?: string;
  studioLogoImagename?: string;
  logoDeleted?: boolean;
  logoLightDeleted?: boolean;
  iconDeleted?: boolean;
  studioLogoDeleted?: boolean;
  buttonStyleColor?: string;
  stylesBackgroundColor?: string;
  customDomain?: string;
  languageApp?: number;
  [key: string]: any;
}

interface SetDefaultValuesOwnProps {
  auth: Auth;
  notify: Notify;
  initialValues: InitialValues;
  isMobileDevice: boolean;
  accountView?: boolean;
  userBrandId?: string;
  updateCurrentUser: (data: Auth, notify: Notify | null, redirect: string) => void;
  updateUserBrand: (data: any, notify: Notify | null) => void;
  uploadDefaultUserImage: (data: {
    type: string;
    userBrandId: string;
    file: File;
    auth: Auth;
    notify: Notify;
  }) => Promise<ImageData>;
}

type SetDefaultValuesProps = SetDefaultValuesOwnProps &
  InjectedFormProps<SetDefaultValuesFormValues, SetDefaultValuesOwnProps>;

class SetDefaultValues extends Component<SetDefaultValuesProps, SetDefaultValuesState> {
  constructor(props: SetDefaultValuesProps) {
    super(props);
    this.state = {
      activeTab: 'contactInfo'
    };
    this.submit = this.submit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.imageSelected = this.imageSelected.bind(this);
    this.deleteLogoByKey = this.deleteLogoByKey.bind(this);

    contactInfoFields = {
      company: {
        type: 'text',
        title: getTranslationKey('defaultValues.company'),
        placeholder: getTranslationKey('defaultValues.companyPlaceholder')
      },
      website: {
        type: 'text',
        title: getTranslationKey('defaultValues.website'),
        placeholder: getTranslationKey('defaultValues.website')
      },
      email: {
        type: 'text',
        title: getTranslationKey('defaultValues.email'),
        placeholder: getTranslationKey('defaultValues.emailPlaceholder')
      },
      tel: {
        type: 'text',
        title: getTranslationKey('defaultValues.tel'),
        placeholder: getTranslationKey('defaultValues.telPlaceholder')
      }
    };

    socialFields = {
      facebook: {
        type: 'text',
        title: getTranslationKey('yourFBAccount'),
        placeholder: getTranslationKey('yourFBAccountPH')
      },
      instagram: {
        type: 'text',
        title: getTranslationKey('yourIGAccount'),
        placeholder: getTranslationKey('yourIGAccountPH')
      },
      twitter: {
        type: 'text',
        title: getTranslationKey('yourTTAccount'),
        placeholder: getTranslationKey('yourTTAccountPH')
      },
      pinterest: {
        type: 'text',
        title: getTranslationKey('yourPRAccount'),
        placeholder: getTranslationKey('yourPRAccountPH')
      },
      youtube: {
        type: 'text',
        title: getTranslationKey('yourYTAccount'),
        placeholder: getTranslationKey('yourYTAccountPH')
      },
      linkedin: {
        type: 'text',
        title: getTranslationKey('yourLIAccount'),
        placeholder: getTranslationKey('yourLIAccountPH')
      },
      googleReviews: {
        type: 'text',
        title: getTranslationKey('yourGRAccount'),
        placeholder: getTranslationKey('yourGRAccountPH')
      }
    };

    legalFields = {
      custom_imprint: {
        type: 'text',
        placeholder: getTranslationKey('custom_imprint_placeholder'),
        title: getTranslationKey('custom_imprint')
      },
      custom_privacy: {
        type: 'text',
        placeholder: getTranslationKey('custom_privacy_placeholder'),
        title: getTranslationKey('custom_privacy')
      }
    };
  }

  componentDidMount() {
    window.scroll(0, 0);
  }

  toggle(activeTab: string) {
    this.setState({ activeTab });
  }

  imageSelected(type: string, files: FileList) {
    const { auth } = this.props;
    if (auth.defaultValues && auth.defaultValues[type] && auth.defaultValues[type].url) {
      if (window.confirm(getTranslationKey('defaultValues.rlyUpload'))) {
        this.uploadImage(type, files);
      }
    } else this.uploadImage(type, files);
  }

  async deleteLogoByKey(logoType: string) {
    const { notify, userBrandId } = this.props;
    try {
      console.log('deleteLogoByKey', logoType);

      await axios.delete('/api/userBrand/logo', { params: { userBrandId, logoType } });

      notify({
        title: getTranslationKey('success'),
        message: getTranslationKey('successfullyDeleted'),
        status: 'success',
        position: 'top-center',
        dismissible: true,
        dismissAfter: 3000
      });

      this.setState({
        [logoType]: undefined,
        [`${logoType}Uploading`]: false,
        [`${logoType}Imagename`]: undefined,
        [`${logoType}Deleted`]: true
      });
    } catch (error) {
      console.log(error);
      notify({
        title: getTranslationKey('error'),
        message: getTranslationKey('generalError'),
        status: 'error',
        position: 'top-center',
        dismissible: true,
        dismissAfter: 3000
      });
    }
  }

  async uploadImage(type: string, files: FileList) {
    const { auth, uploadDefaultUserImage, notify, userBrandId } = this.props;
    try {
      this.setState({ [`${type}Uploading`]: true });

      const newImage = await uploadDefaultUserImage({
        type,
        userBrandId: userBrandId || auth.defaultUserBrand._id || auth.defaultUserBrand,
        file: files[0],
        auth,
        notify
      });

      this.setState({
        [type]: newImage,
        [`${type}Uploading`]: false,
        [`${type}Imagename`]: files[0].name,
        [`${type}Deleted`]: false
      });
    } catch (e) {
      console.log(e);
      notify({
        title: getTranslationKey('error'),
        message: getTranslationKey('generalError'),
        status: 'error',
        position: 'top-center',
        dismissible: true,
        dismissAfter: 3000
      });
    }
  }

  async submit(_values: SetDefaultValuesFormValues, activeTab: string) {
    const { updateCurrentUser, auth, notify, initialValues, accountView, updateUserBrand } =
      this.props;
    const {
      logo,
      logoLight,
      icon,
      studioLogo,
      buttonStyleColor,
      stylesBackgroundColor,
      customDomain,
      languageApp
    } = this.state;

    let customDomainValue = initialValues.customDomain;
    if (customDomain) {
      if (customDomain === 'select') customDomainValue = null;
      else customDomainValue = customDomain;
    }

    const values = {
      ..._values,
      logo: logo || initialValues.logo,
      logoLight: logoLight || initialValues.logoLight,
      icon: icon || initialValues.icon,
      studioLogo: studioLogo || initialValues.studioLogo,

      language: languageApp || auth.languageApp,

      customDomain: customDomainValue,
      buttonStyle: {
        color: buttonStyleColor || (initialValues.buttonStyle && initialValues.buttonStyle.color)
      },
      styles: {
        backgroundColor:
          stylesBackgroundColor || (initialValues.styles && initialValues.styles.backgroundColor)
      }
    };

    const { custom_imprint, custom_privacy, company } = values;
    delete values.custom_privacy;
    delete values.custom_imprint;

    let redirect = '';
    const setDefaultValues = activeTab === 'legal' || accountView;

    if ((auth.type === 'PP' || auth.type === 'VST') && activeTab === 'legal') {
      redirect = '/dashboard';
    }

    updateUserBrand(values, auth.type === 'SB' && !accountView ? null : notify);

    if (!accountView) {
      updateCurrentUser(
        {
          ...auth,
          custom_imprint,
          custom_privacy,
          company: auth.company || company,
          registrationProcess: {
            ...auth.registrationProcess,
            setDefaultValues
          }
        },
        auth.type !== 'SB' ? notify : null,
        auth.type !== 'SB' ? redirect : ''
      );
    }
  }

  renderButton(nextStep: string) {
    const { accountView } = this.props;

    if (accountView || nextStep === 'save') {
      return (
        <Button color="success" className="px-4 w-100-p m-b-10" type="submit">
          {accountView ? getTranslationKey('save') : getTranslationKey('nextStep')}
        </Button>
      );
    }

    return (
      <Row>
        <Col xs="12" className="text-center">
          <Button
            color="success"
            className="px-4 w-100-p m-b-10"
            onClick={() => this.toggle(nextStep)}
          >
            {getTranslationKey('nextStep')}
          </Button>
          <span onClick={() => this.toggle(nextStep)} className="text-underline cursor-pointer">
            {getTranslationKey('defaultValues.skip')}
          </span>
        </Col>
      </Row>
    );
  }

  renderTab(type: string) {
    const { initialValues, auth } = this.props;
    switch (type) {
      case 'contactInfo':
        return Object.keys(contactInfoFields).map((fieldKey, index) => (
          <Field
            component={InputGroup}
            key={index}
            name={fieldKey}
            field={contactInfoFields[fieldKey]}
          />
        ));
      case 'socialMedia':
        return Object.keys(socialFields).map((fieldKey, index) => (
          <Field
            component={InputGroup}
            key={index}
            name={fieldKey}
            field={socialFields[fieldKey]}
          />
        ));
      case 'images':
        let logoKeys = ['logo', 'logoLight', 'studioLogo'];
        if (auth.type !== 'SB') logoKeys = ['icon', ...logoKeys];

        return logoKeys.map((logo, key) => (
          <FormGroup key={key} row>
            <Col md="4">
              <Label>{getTranslationKey(`defaultValues.${logo}`)}</Label>
              <br />
              <Label className="text-muted line-height-1">
                <small>{getTranslationKey(`defaultValues.${logo}Desc`)}</small>
              </Label>
            </Col>
            <Col xs="12" md="8">
              <label
                className={`btn btn-primary btn-sm w-100-p btn-icon text-center pt-upload-brand-${logo}`}
              >
                <Input
                  type="file"
                  onChange={({ target: { files } }: ChangeEvent<HTMLInputElement>) =>
                    files && this.imageSelected(logo, files)
                  }
                  name={logo}
                  accept="image/*"
                  multiple={false}
                  className="hidden-upload"
                />{' '}
                <i className="icon-picture" /> {getTranslationKey('selectFile')}
              </label>
              {this.state[`${logo}Uploading`] && (
                <Progress className="m-t-10" animated color="success" value="100">
                  {getTranslationKey('defaultValues.uploading')}
                </Progress>
              )}
              {!this.state[`${logo}Deleted`] &&
              !this.state[`${logo}Uploading`] &&
              (this.state[`${logo}Imagename`] ||
                (initialValues && initialValues[logo] && initialValues[logo].originalImageName)) ? (
                <p className="alert alert-success m-t-10">
                  {getTranslationKey('defaultValues.currentImage')}{' '}
                  {this.state[`${logo}Imagename`] || initialValues[logo]!.originalImageName}
                  <FaRegTrashAlt
                    onClick={partial(this.deleteLogoByKey, logo)}
                    className="float-right cursor-pointer"
                    color={theme.commonColors.second}
                    size={18}
                  />
                </p>
              ) : null}
            </Col>

            <Col xs="12">
              <hr />
            </Col>
          </FormGroup>
        ));
      case 'legal':
        return Object.keys(legalFields).map((fieldKey, index) => (
          <Field component={InputGroup} key={index} name={fieldKey} field={legalFields[fieldKey]} />
        ));
      default:
        return null;
    }
  }

  render() {
    const { handleSubmit, accountView, isMobileDevice } = this.props;
    const { activeTab } = this.state;

    return (
      <Form onSubmit={handleSubmit((values) => this.submit(values, activeTab))}>
        <Nav tabs>
          <NavItem className={!accountView && isMobileDevice ? 'd-md-down-none' : ''}>
            <NavLink
              className={classnames(
                { active: activeTab === 'contactInfo' },
                'help_setupBrand_contact'
              )}
              onClick={() => this.toggle('contactInfo')}
            >
              {getTranslationKey('defaultValues.contactInfo')}
            </NavLink>
          </NavItem>
          <NavItem className={!accountView && isMobileDevice ? 'd-md-down-none' : ''}>
            <NavLink
              className={classnames(
                {
                  active: activeTab === 'images'
                },
                'help_setupBrand_logos'
              )}
              onClick={() => {
                this.toggle('images');
              }}
            >
              {getTranslationKey('defaultValues.logos')}
            </NavLink>
          </NavItem>
          <NavItem className={!accountView && isMobileDevice ? 'd-md-down-none' : ''}>
            <NavLink
              className={classnames(
                {
                  active: activeTab === 'socialMedia'
                },
                'help_setupBrand_social'
              )}
              onClick={() => {
                this.toggle('socialMedia');
              }}
            >
              {getTranslationKey('defaultValues.socialMedia')}
            </NavLink>
          </NavItem>
          <NavItem className={!accountView && isMobileDevice ? 'd-md-down-none' : ''}>
            <NavLink
              className={classnames({
                active: activeTab === 'legal',
                hidden: accountView
              })}
              onClick={() => {
                this.toggle('legal');
              }}
            >
              {getTranslationKey('defaultValues.legalTitle')}
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="contactInfo">
            <p className="text-muted">{getTranslationKey('defaultValues.contactInfo_sub_title')}</p>
            {this.renderTab('contactInfo')}
            {this.renderButton('images')}
          </TabPane>
          <TabPane tabId="images">
            <p className="text-muted">{getTranslationKey('defaultValues.images_sub_title')}</p>
            {this.renderTab('images')}
            {this.renderButton('socialMedia')}
          </TabPane>
          <TabPane tabId="socialMedia">
            <p className="text-muted">{getTranslationKey('defaultValues.social_sub_title')}</p>
            {this.renderTab('socialMedia')}
            {this.renderButton('legal')}
          </TabPane>
          <TabPane tabId="legal">
            <p className="text-muted">{getTranslationKey('defaultValues.legal_sub_title')}</p>
            {this.renderTab('legal')}
            {this.renderButton('save')}
          </TabPane>
        </TabContent>
      </Form>
    );
  }
}

const SetDefaultValuesForm = reduxForm<SetDefaultValuesFormValues, SetDefaultValuesOwnProps>({
  form: 'setDefaultValuesForm',
  enableReinitialize: true,
  destroyOnUnmount: false
})(SetDefaultValues);

function mapStateToProps(
  { auth, notify, userBrands, environment: { isMobileDevice } }: any,
  { userBrandId }: any
) {
  const defaults = userBrandId
    ? userBrands[userBrandId]
    : userBrands[auth.defaultUserBrand._id || auth.defaultUserBrand];

  const initialValues: InitialValues = {
    ...defaults,
    custom_imprint: auth.custom_imprint,
    custom_privacy: auth.custom_privacy
  };

  return {
    auth,
    initialValues,
    notify,
    isMobileDevice
  };
}

export default connect(mapStateToProps, actions)(SetDefaultValuesForm);
